import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["aria-selected", "onClick"]
const _hoisted_3 = { class: "filter-text" }

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export type WagerStatusFilterValue = 'all' | 'open' | 'won' | 'lost'

export interface WagerStatusCounts {
  all: number
  open: number
  won: number
  lost: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WagerStatusFilters',
  props: {
    modelValue: {},
    counts: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props



const { t } = useI18n()

const options = computed(() => [
  { value: 'all' as const, label: t('wagers.filterAll'), count: props.counts.all },
  { value: 'open' as const, label: t('wagers.open'), count: props.counts.open },
  { value: 'won' as const, label: t('wagers.won'), count: props.counts.won },
  { value: 'lost' as const, label: t('wagers.lost'), count: props.counts.lost },
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "wager-status-filters",
    role: "tablist",
    "aria-label": _ctx.$t('wagers.filterByStatus')
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
      return (_openBlock(), _createElementBlock("button", {
        key: option.value,
        type: "button",
        role: "tab",
        class: _normalizeClass(["wager-status-filter", { active: _ctx.modelValue === option.value }]),
        "aria-selected": _ctx.modelValue === option.value,
        onClick: ($event: any) => (_ctx.$emit('update:modelValue', option.value))
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(option.label) + " " + _toDisplayString(option.count), 1)
      ], 10, _hoisted_2))
    }), 128))
  ], 8, _hoisted_1))
}
}

})